<wo-table-action
  [icon]="'eye'"
  [tooltip]="'View'"
/>
